module.exports = "pegasus/assets/background-patterns/subtle-blue-mini-waves.png";